import axios from "axios";

import { authApi } from "../../utils/axios";
import { config } from "../../utils/config";
import { updateUserInfo } from "../slices/userSlice";

export const EDIT_PROFILE_SUCCESS = 'EDIT_PROFILE_SUCCESS';
export const EDIT_PROFILE_FAILURE = 'EDIT_PROFILE_FAILURE';
export const EDIT_PROFILE_REQUEST = 'EDIT_PROFILE_REQUEST';

export async function googleLoginRequest(idToken, onSuccess, onFail) {
  try {
    const data = await authApi({
      method: "post",
      url: `/auth/login/google`,
      data: { id_token: idToken },
      encoding: null,
    });

    if (typeof onSuccess === "function") onSuccess(data.data);
  } catch (err) {
    if (typeof onFail === "function") onFail();
  }
}

export async function appleLoginRequest(
  appleSignInResponse,
  onSuccess,
  onFail
) {
  try {
    const data = await authApi({
      method: "post",
      url: `/auth/login/apple`,
      data: appleSignInResponse,
      encoding: null,
    });

    if (typeof onSuccess === "function") onSuccess(data.data);
  } catch (err) {
    if (typeof onFail === "function") onFail();
  }
}

export async function refreshTokens(refresh, onSuccess, onFail) {
  try {
    const refreshToken = refresh.token;

    const data = await authApi({
      method: "post",
      url: `/auth/refresh-tokens`,
      data: { refreshToken: refreshToken },
      encoding: null,
    });

    if (typeof onSuccess === "function") onSuccess(data.data);
  } catch (err) {
    if (typeof onFail === "function") onFail();
  }
}

export async function getUserProfile(access) {
  const accessToken = access.token;

  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };

  const data = await authApi({
    method: "get",
    url: `/users/my-profile`,
    headers: headers,
    encoding: null,
  });

  return data.data;
}

// export const editProfile = (updateBody, onSuccess, onFail) => {
//   return function (dispatch) {
//     return axios
//       .put(`users/profile`, updateBody)
//       .then(({ data }) => {
//         dispatch({
//           payload: data,
//         });
//         onSuccess && onSuccess()
//       })
//       .catch(err => {
//         dispatch({
//           payload: err.response?.data?.message || err.message,
//         });
//         onFail && onFail()
//       });
//   };
// };

export const editProfile = (updateBody, onSuccess, onFail) => {
  return function (dispatch) {
    dispatch({
      type: EDIT_PROFILE_REQUEST,
    });
    return authApi
      .put(`/users/profile`, updateBody)
      .then(({ data }) => {
        dispatch({
          type: EDIT_PROFILE_SUCCESS,
          payload: data,
        });
        dispatch(updateUserInfo({ userData: data }));
        onSuccess && onSuccess()
      })
      .catch(err => {
        dispatch({
          type: EDIT_PROFILE_FAILURE,
          payload: err.response?.data?.message || err.message,
        });
        onFail && onFail()
      });
  };
};

export async function loginWithEmailPhone(
  email,
  telephone,
  password,
  onSuccess,
  onFail
) {
  try {
    const body = {
      ...(email && { email }),
      ...(telephone && { telephone }),
      password,
    };

    const data = await authApi({
      method: "post",
      url: `/auth/login`,
      data: body,
      encoding: null,
    });

    if (typeof onSuccess === "function") onSuccess(data.data);
  } catch (err) {
    if (typeof onFail === "function") onFail(err?.response?.data?.message);
  }
}

export async function registration(registrationInfo, onSuccess, onFail) {
    try {

        const {email, telephone, password} = registrationInfo

        const body = {
          ...(email && { email }),
          ...(telephone && { telephone }),
            password,
          };
          
          const data = await authApi({
            method: 'post',
            url: `/auth/signup`,
            data: body,
            encoding: null
        })

        if (typeof onSuccess === 'function') onSuccess(data.data, registrationInfo)
    }

    catch (err) {
        if (typeof onFail === 'function') onFail(err?.response?.status, registrationInfo)
    }
}

export async function verifyAccount (confirmationCode, user, onSuccess, onFail) {
    try {
        const accessToken = user.tokens.access.token
        const headers = {
            'Authorization': `Bearer ${accessToken}`
        }

        const data = await authApi({
            method: 'patch',
            url: `/auth/activate-account`,
            headers: headers,
            data: {activationCode: confirmationCode},
            encoding: null
        })  

        const resp = {user: data.data?.user, 
                      tokens: {access: user.tokens.access, 
                               refresh: user.tokens.refresh}}

        if (typeof onSuccess === 'function') onSuccess(resp)
    }

    catch (err) {
        if (typeof onFail === 'function') onFail(err)
          
    }
}

  export async function signupWithEmailPhone(
    fullName,
    email,
    password,
    onSuccess,
    onFail
  ) {
    try {
      const body = {
        fullName,
        email,
        password,
      };

      const data = await authApi({
        method: "post",
        url: `/auth/signup`,
        data: body,
      });

      if (typeof onSuccess === "function") onSuccess(data.data);
    } catch (err) {
      if (typeof onFail === "function") onFail(err?.response?.data?.message);
    }
  }

  export async function activateTemporaryAcc (confirmationCode, registrationInfo, onSuccess, onFail){
    
    try {
        const data = await authApi({
            method: 'post',
            url: `/auth/activate-temporary-account`,
            data: {activationCode: confirmationCode, 
                ...(registrationInfo.email? {email: registrationInfo.email} : {telephone: registrationInfo.telephone})},
            encoding: null
        })

        if (typeof onSuccess === 'function') onSuccess(data.data)
    }

    catch (err) {
        if (typeof onFail === 'function') onFail(err)
    }
}

export async function resendVerificationCode(registrationInfo, user, onSuccess, onFail) {
    try{
        const {email, telephone} = registrationInfo

        if (email || telephone) {
            const body = {
            ...(email && { email }),
            ...(telephone && { telephone }),
            }

            const headers = {}
            const accessToken = user?.tokens?.access?.token
            if (accessToken) {
                headers['Authorization'] = `Bearer ${accessToken}`
            }

            await authApi({
                method: 'post',
                url: `/auth/resend-activate-account`,
                data: body,
                headers: headers,
                encoding: null
            })

            if (typeof onSuccess === 'function') onSuccess()
        }
    }
    catch (err){
        if (typeof onFail === 'function') onFail()

    }
}


export async function forgotPassword(email, onSuccess, onFail) {
  try {
    const body = {
      ...(email && { email }),
    };

    await authApi({
      method: "post",
      url: `/auth/forgot-password`,
      data: body,
      encoding: null,
    });

    if (typeof onSuccess === "function") onSuccess();
  } catch (err) {
    if (typeof onFail === "function") onFail();
  }
}

export async function resetAccountPassword(
  email,
  telephone,
  password,
  resetPasswordCode,
  onSuccess,
  onFail
) {
  try {
    const body = {
      ...(email && { email }),
      ...(telephone && { telephone }),
      password,
      resetPasswordCode,
    };

    await authApi({
      method: "patch",
      url: `/auth/reset-password`,
      data: body,
      encoding: null,
    });

    if (typeof onSuccess === "function") await onSuccess();
  } catch (err) {
    if (typeof onFail === "function") onFail();
  }
}

export async function logoutUser() {
  try {
    await authApi({
      method: "post",
      url: `/auth/logout`,
    });
  } catch (err) {
  }
}

// Fetch stock avatar images
export const fetchStockAvatars = async () => {
  const response = await authApi.get("/users/stock-images/AVATARS");
  // API returns pre-grouped arrays of 3 — flatten for display
  return response.data.flat();
};

// Upload a profile image file
export const uploadProfileImage = async (file) => {
  const formData = new FormData();
  formData.append("files", file);

  const response = await authApi({
    method: "POST",
    url: "/files/upload",
    params: { purpose: "userImg" },
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
  });

  return response.data[0].s3Url;
};
